import type { ExpenseCategory, PaymentMethod } from '../../types';

/** One detected expense, as edited in the review list before anything is saved. */
export interface ScannedRow {
  key:           string;
  checked:       boolean;
  description:   string;
  amount:        string;
  currency:      string;
  date:          string;
  category:      ExpenseCategory;
  paymentMethod: PaymentMethod;
  status:        'PAID' | 'PENDING';
}

/** A row can only be saved once it has the three fields the API demands. */
export function rowIsValid(row: ScannedRow): boolean {
  return row.description.trim().length > 0 && parseFloat(row.amount) > 0 && !!row.date;
}
